module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1d.c28575ec.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-1d.mp3
// module id = 504
// module chunks = 0